import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-cabecalho-direita',
  templateUrl: './cabecalho-direita.component.html',
  styleUrls: ['./cabecalho-direita.component.scss']
})

export class CabecalhoDireitaComponent implements OnInit {
  @Input() data;
  
  constructor() {
  }

  ngOnInit() {
  }
}
